/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type InventoryChangeReason =
  | "CORRECTION"
  | "CORRECTION_BAKING_INGREDIENTS"
  | "CORRECTION_BREAK_IN"
  | "CORRECTION_ORDER_CANCELLATION_RETURN"
  | "EOY_INVENTORY_CHECK"
  | "EOY_INVENTORY_RECOUNT"
  | "EXTRA_CHECK"
  | "INBOUND_BULK"
  | "INBOUND_GOODS_RECEIVED"
  | "INBOUND_ORDER_CANCELLATION"
  | "INBOUND_STOCK_TRANSFER"
  | "INBOUND_SURPRISE_BAG"
  | "LOW_STOCK_CHECK"
  | "ORDER_CANCELLED"
  | "ORDER_CREATED"
  | "OUTBOUND_DELIVERY_PRODUCT_DAMAGED"
  | "OUTBOUND_DELIVERY_PRODUCT_EXPIRED"
  | "OUTBOUND_EQUIPMENT_FAILURE"
  | "OUTBOUND_HUB_CLOSURE"
  | "OUTBOUND_ORDER_CANCELLATION_NOT_RETURNED"
  | "OUTBOUND_ORDER_CANCELLATION_NOT_SELLABLE"
  | "OUTBOUND_PRODUCT_DAMAGED"
  | "OUTBOUND_PRODUCT_EXPIRED"
  | "OUTBOUND_STOCK_TRANSFER"
  | "OUTBOUND_SURPRISE_BAG"
  | "OUTBOUND_TOO_GOOD_TO_GO"
  | "OUT_OF_STOCK_CHECK"
  | "POST_INBOUND_CORRECTION"
  | "PRODUCT_RECALL"
  | "REQUESTED_FROM_INBOUND_CORRECTION"
  | "ROLLING_INVENTORY_CHECK"
  | "UNSPECIFIED";

export type ProductInput = {
  quantity: number;
  sku: string;
};

export type UpdateSurpriseBagStockInput = {
  products?: Array<ProductInput> | null | undefined;
  reason: InventoryChangeReason;
  sku: string;
  transactionId: string;
};

export type UpdateSurpriseBagStockMutationVariables = Exact<{
  input: Types.UpdateSurpriseBagStockInput;
}>;

export type UpdateSurpriseBagStockMutation = { updateSurpriseBagStock: { success: boolean } };

export const UpdateSurpriseBagStockDocument = gql`
  mutation UpdateSurpriseBagStock($input: UpdateSurpriseBagStockInput!) {
    updateSurpriseBagStock(updateSurpriseBagStockInput: $input) {
      success
    }
  }
`;
export type UpdateSurpriseBagStockMutationFn = Apollo.MutationFunction<
  UpdateSurpriseBagStockMutation,
  UpdateSurpriseBagStockMutationVariables
>;

/**
 * __useUpdateSurpriseBagStockMutation__
 *
 * To run a mutation, you first call `useUpdateSurpriseBagStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurpriseBagStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurpriseBagStockMutation, { data, loading, error }] = useUpdateSurpriseBagStockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurpriseBagStockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSurpriseBagStockMutation,
    UpdateSurpriseBagStockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSurpriseBagStockMutation,
    UpdateSurpriseBagStockMutationVariables
  >(UpdateSurpriseBagStockDocument, options);
}
export type UpdateSurpriseBagStockMutationHookResult = ReturnType<
  typeof useUpdateSurpriseBagStockMutation
>;
export type UpdateSurpriseBagStockMutationResult =
  Apollo.MutationResult<UpdateSurpriseBagStockMutation>;
export type UpdateSurpriseBagStockMutationOptions = Apollo.BaseMutationOptions<
  UpdateSurpriseBagStockMutation,
  UpdateSurpriseBagStockMutationVariables
>;
